import HistoryDialogMobileView from './mobile/HistoryDialog.mobile.view';
import HistoryDialogDesktopView from './desktop/HistoryDialog.desktop.view';
import type HistoryDialogProperties from './HistoryDialog.properties.ts';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function HistoryDialogView(props: HistoryDialogProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <HistoryDialogMobileView {...props} />}
      {isDesktop && <HistoryDialogDesktopView {...props} />}
    </>
  );
}
